import React from "react";
import { withTranslation } from "react-i18next";
import { Button, CircularProgress, Grid } from "@mui/material";
import PropTypes from "prop-types";
import * as Yup from "yup";
import { useFormik } from "formik";

import Modal from "Components/Common/Modal";
import Backdrop from "Components/Common/Backdrop";
import InputFieldText from "Components/Common/InputFieldText";

import { onlyNumberKeys } from "utils";

import {
  useGetDemandEstimationByApplicationIdQuery,
  usePostDemandEstimationForOtherUtilityMutation,
} from "apis/DemandEstimation";

const DemandEstimateForm = ({ t, applicationId, handleClose }) => {
  const [addDemandEstimation, { isLoading }] =
    usePostDemandEstimationForOtherUtilityMutation();

  const {
    data: { data: demandEstimationData = {} } = {},
    isLoading: isDemandEstimationDataLoading,
  } = useGetDemandEstimationByApplicationIdQuery(applicationId);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      consumerEnergyMeterCharges:
        demandEstimationData?.charges?.consumerEnergyMeterCharges ?? "",
    },
    validationSchema: Yup.object({
      consumerEnergyMeterCharges: Yup.string().required(
        "CEM charge is required"
      ),
    }),
    onSubmit: async (values) => {
      try {
        await addDemandEstimation(applicationId, values);
        handleClose();
      } catch (error) {}
    },
  });

  const { handleSubmit } = formik;

  if (isDemandEstimationDataLoading) {
    return <Backdrop open />;
  }

  return (
    <Modal
      isOpen
      handleClose={handleClose}
      title={t("Demand Estimation")}
      maxWidth="md"
    >
      <Grid container className="mt-3" columnSpacing={2}>
        <Grid item xs={12} md={4} sm={6}>
          <InputFieldText
            label={t("CEM Charge") + "*"}
            name="consumerEnergyMeterCharges"
            formik={formik}
            type="number"
            InputProps={{
              inputProps: { min: 0, onKeyDown: onlyNumberKeys },
            }}
            placeholder={t("Enter CEM charge")}
          />
        </Grid>

        <Grid className="d-block ms-auto" mt={1}>
          <Button
            color="primary"
            variant="contained"
            type="submit"
            disabled={isLoading}
            onClick={handleSubmit}
          >
            Submit {isLoading && <CircularProgress size={20} />}
          </Button>
        </Grid>
      </Grid>
    </Modal>
  );
};

DemandEstimateForm.propTypes = {
  applicationId: PropTypes.number,
  handleClose: PropTypes.func,
  t: PropTypes.func,
};

export default withTranslation()(DemandEstimateForm);
